import { EventEmitter, inject, Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { App } from '@df/core/app';
import { debounceTime, of, Subscription, switchMap, take } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { NDfModuleLoqate } from '../df-module-loqate.config';
import { LoqateService } from '../loqate.service';

@Injectable({
    providedIn: 'root'
})
export class LoqatePhoneValidatorService {
    protected app = inject(App);
    protected loqateService = inject(LoqateService);

    responseSubscription?: Subscription;

    ngOnDestroy() {
        this.responseSubscription?.unsubscribe();
    }

    validatorFunction(
        control: AbstractControl,
        countryCode = 'GB',
        eventEmitter?: EventEmitter<NDfModuleLoqate.PhoneValidationItem[] | undefined>
    ): Observable<ValidationErrors | null> {
        if (!control.value?.length || !this.loqateService.isEnabled) {
            return of(null);
        }

        return control.valueChanges.pipe(
            debounceTime(500),
            take(1),
            switchMap(value => {
                const response = this.loqateService.validatePhone(value, countryCode);

                if (eventEmitter && response) {
                    this.responseSubscription?.unsubscribe();
                    this.responseSubscription = response.subscribe(items => {
                        eventEmitter.next(items);
                    });
                }

                return response;
            }),
            filter(items => !!items),
            map(items => this.loqateService.getPhoneError(items, control.value))
        );
    }

    validate(
        control: AbstractControl,
        countryCode = 'GB',
        eventEmitter?: EventEmitter<NDfModuleLoqate.PhoneValidationItem[] | undefined>
    ): Observable<ValidationErrors | null> {
        return this.validatorFunction(control, countryCode, eventEmitter);
    }
}
